import type { MouseEvent } from "react";
import type { ProjectIssue } from "@/types/api";

/**
 * Click handler for an issue link that can open the issue in place (the Issues
 * page's desktop side panel). A plain left click is intercepted; a modified
 * click (Cmd/Ctrl/Shift/Alt, middle button) is left to the link, so opening an
 * issue in a new tab still goes to its own page.
 */
export function openIssueClick(
  issue: ProjectIssue,
  onOpen: ((issue: ProjectIssue) => void) | undefined,
) {
  if (!onOpen) return undefined;
  return (event: MouseEvent<HTMLAnchorElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }
    event.preventDefault();
    onOpen(issue);
  };
}
